import { InspectionImageSchema } from "../_offline/models/inspectionImage.schema";
import { InspectionImage } from "./inspection-image";

export class AnnotationImageDetail {
  /** 検査画像データID */
  id: string;

  /** アノテーションオブジェクト */
  modifiedItems: any;

  /** 編集後画像の幅 */
  modifiedWidth: number;

  /** 編集後画像の高さ */
  modifiedHeight: number;

  /** 編集画像のモード判定 */
  usedImageMode: number;

  /** 最終更新者のObjectID */
  lastUpdatedBy: string;

  /** アノテーションオブジェクト */
  measurementItems: any;

  /** 計測画像の幅 */
  measurementWidth: number;

  /** 計測画像の高さ */
  measurementHeight: number;

  setInspectionImageSchema(schema: InspectionImageSchema) {
    this.id = schema.id;
    this.modifiedItems = JSON.parse(schema.modifiedItems);
    this.modifiedWidth = schema.modifiedWidth;
    this.modifiedHeight = schema.modifiedHeight;
    this.usedImageMode = schema.usedImageMode;
    this.lastUpdatedBy = schema.lastUpdatedBy;
    this.measurementItems = JSON.parse(schema.measurementItems);
    this.measurementWidth = schema.measurementWidth;
    this.measurementHeight = schema.measurementHeight;
  }
}

export class AnnotationObjectForUpdate {
  /** 検査画像データID */
  id: string;

  /** アノテーションオブジェクト */
  modifiedItems: object;

  /** アノテーションオブジェクト */
  measurementItems: object;

  /** アノテーションオブジェクト */
  usedImageMode: number;

  /** 多重更新制御用パラメータ */

  /** スキーマバージョン */
  schemaVersion: string;

  constructor(inspectionImageId: string, modifiedItems: any, measurementItems: any, schemaVersion: string) {
    this.id = inspectionImageId;
    this.modifiedItems = modifiedItems;
    this.measurementItems = measurementItems;
    this.schemaVersion = schemaVersion;
  }
}
